// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader__wrapper--2CU-U","pulse":"Loader__pulse--25LMD"};